export default function getProductRoute ({ product, lang }) {
  if (product.category?.includes('136')) {
    return {
      name: `${lang}-giftcards`,
      query: { id: product.cId, slug: product.slug }
    }
  }
  const warchildIds = [85508, 85506, 85510, 95728, 95730, 95732, 95734, 96330, 96445, 98667]
  if (warchildIds.includes(parseInt(product.cId))) {
    return {
      name: `${lang}-warchild`,
      query: { id: product.cId, slug: product.slug }
    }
  }

  return {
    name: `${lang}-product-slug-id`,
    params: { id: product.cId, slug: product.slug }
  }
}
